import { useState, useEffect, useMemo } from 'react';
import { MAX_MOBILE_SCREEN_WIDTH } from '../marketplace-custom-config';

/**
 * Custom hook to determine if the current viewport is mobile sized
 * @returns {boolean} - True if viewport is mobile sized
 */
const useIsMobile = () => {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );

  // Add window resize listener
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Memoize the return values to prevent unnecessary rerenders
  const values = useMemo(
    () => ({
      isMobile: windowWidth <= MAX_MOBILE_SCREEN_WIDTH,
      windowWidth,
    }),
    [windowWidth]
  );

  return values;
};

export default useIsMobile;
